import AclName from '../AclName.js';

const excluded = [
  AclName.CrmPageSubscriptionPanel,
  AclName.DemoMessageStart,
  AclName.StaffAccessAll,
  AclName.SettlementsBrokerView,
  AclName.CrmAddNewAsIndustryTypeAo,
  AclName.CrmSectionSystemBalancePrepaid,

  // Developer settings
  AclName.UserInfoDialogAccess,
];

export default Object.values(AclName).filter((acl) => !excluded.includes(acl));
